//import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'

//Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        gToken: "",
        userid: 0
    },
    mutations: {
        gToken(state, token) {
            state.gToken = token;
        },
        userid(state, userid) {
            state.userid = userid;
        }
    },
    getters: {
        getGToken (state) {
            return state.gToken;
        },
        getUserid (state) {
            return state.userid;
        }
    },
    plugins: [createPersistedState(
        {
            key: 'limar',
            paths: ['gToken'],
            storage: window.sessionStorage
        }
    )]
})
